module.exports = __webpack_public_path__ + "static/img/pay.22b8512.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/pay.png
// module id = Ne6e
// module chunks = 1